/**
 * @generated SignedSource<<cbd10082d704d33e1a3e9502fb713d24>>
 * @relayHash 89c9c6606c3cc7f9e98c234f63e138f9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 53dad722b9392cc0d8fb000b7813f8dc5b4c5bbea45d2a785e57afe7c6db80c4

import type { ConcreteRequest } from 'relay-runtime';
export type CommentDeletionLocation = "EDITOR" | "LIVE" | "%future added value";
export type CommentDeleteInlineCommentMutation$variables = {
  commentIdToDelete: string;
  deleteFrom?: CommentDeletionLocation | null;
};
export type CommentDeleteInlineCommentMutation$data = {
  readonly deleteComment: boolean | null;
};
export type CommentDeleteInlineCommentMutation = {
  response: CommentDeleteInlineCommentMutation$data;
  variables: CommentDeleteInlineCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "commentIdToDelete"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "deleteFrom"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentIdToDelete",
        "variableName": "commentIdToDelete"
      },
      {
        "kind": "Variable",
        "name": "deleteFrom",
        "variableName": "deleteFrom"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteComment"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "CommentDeleteInlineCommentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommentDeleteInlineCommentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "89c9c6606c3cc7f9e98c234f63e138f9",
    "id": "53dad722b9392cc0d8fb000b7813f8dc5b4c5bbea45d2a785e57afe7c6db80c4",
    "metadata": {},
    "name": "CommentDeleteInlineCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CommentDeleteInlineCommentMutation($commentIdToDelete:ID!,$deleteFrom:CommentDeletionLocation){deleteComment(commentIdToDelete:$commentIdToDelete,deleteFrom:$deleteFrom)}"
  }
};
})();

(node as any).hash = "985100db430c5b7c44c5f1e2701cbfdc";

export default node;
